import { useCallback, useState, useSyncExternalStore } from 'react';
import { BarChart3, ChevronDown } from '../../icons';
import type { MyTaskDto } from '../../api/tasks';
import { StatusBar } from './MyTasksInsights';
// 2026-08-26 — '프로젝트 쏠림' 을 대신하는 중요×급함 4분면. 신규 파일.
// 2026-08-28 — 그 4분면을 '순서대로 해야 할 일'(1~4순위 목록) 로 갈아 끼웠다. 신규 파일.
//   ⛔ 2026-10-10 정정 — ★ 종전 줄은 「PriorityMatrix 는 ⭐ 지우지 않는다 — 되돌리려면
//     이 import 와 아래 한 줄만 되돌리면 된다」였다. ⇒ ⛔ 그런데 ★ 그 파일이
//     ⇒ ⇒ ⭐ «우리 트리에 ★ 없다»(2026-10-10 실측: pages/ProjectV2 · pages/ProjectPage ★ 둘 다 ⛔).
//   ⇒ ⭐ 즉 ★ 「남겨 뒀다」는 ⇒ ⭐ 정본(origin/feature/dev-syk) 쪽 사실이고 ⇒ ★ 우리 것이 ⛔ 아니다.
//   ⇒ ⇒ ★ 그러므로 ⭐ 「되돌리기」는 ⇒ ★ 이 파일만으로 ⭐ 안 된다 — ⇒ 그 파일을 ★ 먼저 들여야 한다.
//   ⇒ ⚠ 그리고 ★ 정본에서도 ⭐ 그것을 «그리는 곳»이 ★ 0 이다 —
//     ⇒ ⇒ ⭐ 정본 주석이 스스로 「⭐ 옛 PriorityMatrix」라 부른다(MyTasksNextUp.test.tsx:14).
//     ⇒ ⇒ ⇒ ★ 즉 ⭐ «되돌림용으로 남긴 파일»이고 ⇒ ★ 지금 ⭐ 쓰이지 않는다.
//
//   ⇒ ⭐⭐ 그래서 ★ 판 G(MyTasksMatrix 세 파일)의 판정은 ⇒ ★ ⭐ «가져올 것이 0» 이다 (2026-10-10 실측)
//     ⇒ ★ 잰 법 ⇒ ⭐ origin/feature/dev-syk 의 ts·tsx·css·md ★ 3,586 파일을 훑어
//        ⇒ ⇒ PriorityMatrix 를 담은 파일 ★ 7 을 찾고 ⇒ ⭐ 주석·글자열을 덮고 ★ 다시 셌다:
//          MyTasksMatrix.test.tsx  ⇒ 코드 ★ 8  ⇒ ⭐ 제 시험
//          MyTasksMatrix.tsx       ⇒ 코드 ★ 1  ⇒ ⭐ 제 CSS import
//          MyTasksNextUp.tsx · MyTasksNextUp.test.tsx · MyTasksNextUpTable.test.tsx
//          MyTasksSummary.tsx · MyTasksMatrix.css  ⇒ 코드 ★ ⭐ 0 — ⇒ 다섯 다 «주석»이다
//        ⇒ ⇒ ⇒ ⛔ ★ «그리는 제품 파일» ⇒ ★ ⭐ 0 (⇒ 제 파일·제 시험·주석을 빼고 센 수)
//     ⇒ ⭐ 그리고 ★ 정본 MyTasksNextUp.tsx:36 이 ⇒ ⭐ 스스로 적는다:
//        ⇒ ⇒ 「PriorityMatrix 컴포넌트 자체는 남겨 둔다 — 소스 회귀 금지.」
//        ⇒ ⇒ ⇒ ★ 즉 ⭐ 정본에서도 «쓰이지 않는» 것이고 ⇒ ★ 그 자리를 대신한 NextUpTable 은
//           ⇒ ⇒ ⭐ 우리에 ★ 이미 있다 — ⇒ 바로 아래 import 가 그것이다.
//
//   ⏳ **만료 조건 — ★ «내놓는 이름»으로**
//     ⇒ ⭐ 누군가 PriorityMatrix 를 ★ 내놓고 ⇒ ★ 그것을 ⭐ «그리는 제품 파일»이
//        ⇒ ⇒ ★ 1 이상이 되는 날 ⇒ ⇒ ⭐ 이 판정을 ★ 다시 재라.
//     ⇒ ⚠ ⛔ 「그 파일이 생겼다」로는 ★ 부족하다 — ⇒ ⭐ 정본엔 ★ 지금도 «있고» ⇒ 안 쓰인다.
//        ⇒ ⇒ ★ 가르는 것은 ⭐ 「★ 그리는 곳이 ⭐ 0 인가」다.
// 2026-09-01 — 그 목록과 옆의 '마감 흐름' 차트를 **표 하나**로 합쳤다. 신규 파일.
//   DueFlow · NextUpList 도 파일째 남는다 — 되돌리려면 이 import 와 아래 한 줄만 되돌린다.
import { NextUpTable } from './MyTasksNextUpTable';
import { tProject, getProjectLang, subscribeProjectLang } from '../../lib/project-i18n';
import './MyTasksSummary.css';

/**
 * MyTasksSummary (2026-08-26) — 내 업무의 요약을 **한 서랍에** 모은다. 신규 파일(목록 로직 무수정).
 *
 * 왜 만들었나: 표 하나를 보러 들어온 화면인데 그 위에 요약이 세 겹으로 쌓여 있었다 —
 *   ① 히어로(완료율 도넛 + 상태 분포 막대 + 범례)  ② 마감 흐름 차트  ③ 프로젝트 쏠림.
 * 셋 다 쓸모는 있지만 **매번 볼 것은 아니다**. 그런데 ①은 늘 떠 있었고 ②③도 기본 펼침이라,
 * 첫 업무 한 줄을 보기까지 화면의 절반을 지나가야 했다.
 *
 * 그래서 지우지 않고 **하나로 합쳐 접었다**:
 *   - 접힌 상태 = 한 줄. 그래도 '완료 n / 전체 m' 은 그 줄에 그대로 적는다(가장 자주 보는 숫자).
 *   - 펼치면 종전 셋이 그대로 나온다 — 도넛·상태바·마감 흐름·프로젝트 쏠림 전부 보존.
 *   - 펼침 여부는 기억한다. 늘 펼쳐 두고 쓰는 사람의 화면을 뺏지 않는다.
 *
 * ⚠ 기본값을 **접힘**으로 둔 것이 종전(MyTasksInsights 는 기본 펼침)과 다른 유일한 점이다.
 *   "있는 줄도 모른다" 는 우려는 접힌 줄 자체가 늘 보이는 것으로 갚는다.
 */

/** 펼침 저장 키 — 개인 UI 선호라 서버에 두지 않는다. v2 = 요약 통합본(옛 insights 키와 분리). */
const LS_KEY = 'wc.mytasks.summary.v2';

function readOpen(): boolean {
  try {
    // 종전 insights 키와 달리 **기본은 접힘**이다 — 목록이 먼저 보이는 편이 맞다.
    return localStorage.getItem(LS_KEY) === '1';
  } catch {
    return false;
  }
}

function writeOpen(v: boolean): void {
  try {
    localStorage.setItem(LS_KEY, v ? '1' : '0');
  } catch {
    /* localStorage 비활성(프라이빗 모드) — 세션 내 동작은 유지 */
  }
}

/** 요약 펼침 상태 — 토글 버튼은 툴바에, 본문은 그 아래에 그리므로 board 가 상태를 쥔다. */
export function useSummaryOpen(): [boolean, () => void] {
  const [open, setOpen] = useState(readOpen);
  const toggle = useCallback(() => {
    setOpen((v) => { writeOpen(!v); return !v; });
  }, []);
  return [open, toggle];
}

/** 툴바에 놓는 한 줄 토글. 접혀 있어도 '완료 n / 전체 m' 은 여기에 남는다. */
export function MyTasksSummaryToggle({ open, onToggle, done, total }: {
  open: boolean; onToggle: () => void; done: number; total: number;
}) {
  useSyncExternalStore(subscribeProjectLang, getProjectLang, getProjectLang);
  return (
    <button
      type="button"
      className={`mts-toggle${open ? ' mts-toggle--on' : ''}`}
      aria-expanded={open}
      onClick={onToggle}
    >
      <BarChart3 size={13} aria-hidden />
      <span className="mts-toggle-label">{tProject('project.mytask.summary_heading')}</span>
      <b className="mts-toggle-count">
        {tProject('project.mytask.done_of_total', { done: String(done), total: String(total) })}
      </b>
      <ChevronDown size={13} aria-hidden className="mts-chevron" />
    </button>
  );
}

/**
 * 펼쳤을 때의 본문 — 완료율 도넛 · 상태 분포 · 마감 흐름 · **순서대로 해야 할 일**.
 *
 * 2026-08-26 — 오른쪽 카드를 '프로젝트 쏠림'(프로젝트별 가로 막대)에서 4분면 점 플롯으로
 * 갈아 끼웠다. 쏠림은 "어느 프로젝트가 나를 먹고 있나" 를 답했지만 알고 나서 할 수 있는
 * 일이 없었고, 같은 자리라면 "그래서 지금 뭘 먼저 잡나" 를 답하는 편이 낫다.
 * (ProjectLoad 컴포넌트 자체는 MyTasksInsights 에 그대로 남겨 둔다 — 소스 회귀 금지.)
 *
 * 2026-08-28 — 그 4분면을 다시 **1~4순위 목록**(NextUpList)으로 바꿨다. 분류 규칙은 그대로고
 * 표현만 바뀐다: 4분면은 두 축의 관계를 정확히 그렸지만 읽는 순서를 사람이 만들어야 했고,
 * 점은 개수만 말할 뿐 "그래서 뭐부터" 에 업무 이름으로 답하지 못했다. 이제 위에서 아래로
 * 읽으면 그게 순서다.
 *   ⇒ ⚠ 종전 줄의 「(PriorityMatrix 도 ★ 파일째 남겨 둔다 — 소스 회귀 금지)」는
 *     ⇒ ⇒ ⛔ ★ 정본 쪽 사실이다 — ⇒ ⭐ 우리에는 ★ 그 파일이 ⭐ 없다(위 :7 정정을 보라).
 */
export function MyTasksSummaryPanel({ items, pct, onPickTask }: {
  items: MyTaskDto[];
  pct: number;
  onPickTask?: (taskId: string) => void;
}) {
  useSyncExternalStore(subscribeProjectLang, getProjectLang, getProjectLang);
  return (
    <section className="mts-panel" aria-label={tProject('project.mytask.summary_heading')}>
      <div className="mts-hero">
        <span className="mtb-donut" style={{ ['--pct' as string]: `${pct}` }} aria-hidden>
          <b>{pct}%</b>
        </span>
        <StatusBar items={items} />
      </div>
      {/*
        2026-09-01 — 카드 둘(마감 흐름 차트 · 1~4순위 목록)을 표 하나로 합쳤다.
        차트는 16칸 중 값이 붙는 칸이 보통 둘뿐이라(지연 · 미정) 폭에 비해 말하는 것이 적었고,
        그 '지연' 은 툴바 칩과 목록의 기한 열에 이미 두 번 더 있었다. 순위 목록도 머리·설명에
        아홉 줄을 쓰면서 정작 업무 이름은 순위마다 셋까지만 폈다.
        표는 같은 정보를 줄 하나에 업무 하나로 편다 — 위에서 아래로 읽으면 그게 순서다.
      */}
      <NextUpTable items={items} onPickTask={onPickTask} />
    </section>
  );
}
